export default __webpack_public_path__ + "static/BnbRev-38f473d498b99c4c9b7b59d1742c3e74.jpg";